import { render, staticRenderFns } from "./VatField.vue?vue&type=template&id=56266f82"
import script from "./VatField.vue?vue&type=script&lang=js"
export * from "./VatField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports